import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    publicKey: String,
    clientSecret: String,
  }

  async connect() {
    this.element.classList.add("min-h-[600px]", "flex", "items-center", "justify-center")
    this.element.innerHTML = `
      <div class="text-center">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-stone-900"></div>
        <p class="mt-4 text-gray-600">Loading secure checkout…</p>
      </div>
    `

    try {
      this.stripe = window.Stripe(this.publicKeyValue)
      this.checkout = await this.stripe.initEmbeddedCheckout({
        clientSecret: this.clientSecretValue,
      })

      this.element.innerHTML = ""
      this.element.classList.remove("min-h-[600px]", "flex", "items-center", "justify-center")
      this.checkout.mount(this.element)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to load Stripe checkout:", error)

      this.element.innerHTML = `
        <div class="text-center p-8 bg-white border border-red-200 rounded-xl">
          <h3 class="text-lg font-semibold text-stone-900 mb-2">Unable to load checkout</h3>
          <p class="text-gray-600 mb-4">Please refresh the page and try again.</p>
          <button type="button" data-action="click->stripe--embedded-checkout#reload" class="rounded-md bg-stone-900 px-4 py-2 text-sm font-semibold text-white hover:bg-stone-800">
            Refresh
          </button>
        </div>
      `
    }
  }

  reload() {
    window.location.reload()
  }

  disconnect() {
    if (this.checkout) {
      this.checkout.destroy()
    }
  }
}
